import { creatorbase } from '@round/api';
import copyComponentRenderToClipboard from 'utility/copyToClipboard/copyComponentRenderToClipboard';
import { PostUrlClipboardTable } from './PostUrlClipboardTable';

export const copyPostUrlsToClipboardTable = (
    campaigns: creatorbase.Campaign[] | creatorbase.PublicCampaign[],
    posts: creatorbase.Post[]
) => {
    const rows =
        campaigns
            ?.map((c) => {
                const campaignPosts =
                    posts?.filter((p): p is creatorbase.TiktokPost => p.campaign_id === c.id && p.status === 'live') ??
                    [];
                return campaignPosts.map((p) => ({
                    campaignName: c.name,
                    url: p.post_url,
                }));
            })
            .flat() ?? [];

    const success = copyComponentRenderToClipboard(
        {
            items: rows,
        },
        PostUrlClipboardTable
    );

    return success;
};
